export enum EvasysResponseStateEnum {
	SUCCESS = 'Success',
	FAILURE = 'Failure',
}
